module.exports = __webpack_public_path__ + "img/SC-PROOF-6999.9c61be88.png";